module.exports = __webpack_public_path__ + "img/signup-view.cca003d0.svg";